import React, { Component } from "react";
import "./about.scss";

export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img
              className="profile-pic"
              src="images/profilepic.png"
              alt="Robert Łajtar"
            />
          </div>

          <div className="nine columns main-col">
            <h2>O mnie</h2>
            <p>{resumeData.aboutme}</p>
            <p>
              {resumeData.aboutme2}
              <a
                href={`mailto:${resumeData.email}?subject=${resumeData.emailSubject}`}
              >
                Napisz do mnie
              </a>
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Kontakt</h2>
                <p className="address">
                  <span>{resumeData.name}</span>
                  <br />
                  <span>{resumeData.address}</span>
                  <br />
                  <a
                    href={resumeData.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {resumeData.website}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
